export default __webpack_public_path__ + "static/media/right-dummy-image.c587c3f5.png";